module.exports = __webpack_public_path__ + "static/media/love-letter_1.3c1aeb60.svg";